import {StageLayer} from "@nolimit/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {FireInTheHole2} from "../FireInTheHole2";
import {BitmapText} from "pixi.js";
import {FITH2FontConfig} from "../configs/FITH2FontConfig";
import {NolimitApplication} from "@nolimit/slot-launcher/bin/NolimitApplication";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";

export class MultiplierView extends PIXI.Container implements StageLayer {
    private _multiplier:BitmapText;
    private _xBombSign:PIXI.Sprite;
    private _multiplierValue:number;
    private _maxWidth:number;
    private _isNormal:boolean;

    constructor() {
        super();
        this.name = "MultiplierView";
        this._maxWidth = 200;
        this.init();
        this.onResize();
    }

    public addOne(multi:number):gsap.core.Timeline {
        this._multiplierValue += multi;
        return gsap.timeline().add([
            ()=>{FITH2SoundManager.playSound("wildMultiplierUp")},
            FireInTheHole2.initialWinView.addMultiValue(),
            this.update(this._multiplierValue)
        ]);
    }

    public update(value:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        const isNormal:boolean = this._isNormal;
        if(value < (isNormal ? 2 : 1)) {
            if(!this._xBombSign.visible) {
                this._xBombSign.alpha = 0;
                this._xBombSign.visible = isNormal;
                tl.add([
                    gsap.to(this._multiplier, 0.2, {alpha : 0}),
                    gsap.to(this._xBombSign, 0.2, {alpha : 1})
                ]);
            }
            tl.add(() => {
                this._multiplier.scale.set(1);
                this._xBombSign.visible = isNormal;
                this._multiplierValue = value;
                this._multiplier.visible = false;
                this._multiplier.scale.set(Math.min(150 / this._multiplier.width, 1));
            });
            return tl;
        }

        this._multiplierValue = value;
        if(this._xBombSign.visible) {
            this._multiplier.alpha = 0;
            this._multiplier.visible = true;
            tl.add(gsap.to(this._xBombSign, 0.2, {alpha : 0}));
        }
        tl.add([
            gsap.to(this._multiplier, 0.2, {alpha : 1}),
            () => {
                this._multiplier.text = `${isNormal ? "x" : ""}${value}${isNormal ? "" : "x"}`;
                const textScale = Math.min(this._maxWidth / this._multiplier.width, 1);
                this._multiplier.scale.set(textScale);
                this._multiplier.visible = true;
                this._multiplier.alpha = 1;
                this._xBombSign.visible = false;
            }]);
        return tl;
    }

    private init():void {
        const container = new PIXI.Sprite(FireInTheHole2.assetLoader.getTextures("board")[0]);
        this._multiplier = new BitmapText("", FITH2FontConfig.MULTIPLIER_GAME_STYLE);
        container.anchor = new PIXI.Point(0.5);
        container.position.set(6, -47);
        this._multiplier.anchor = new PIXI.Point(0.5, 1);
        this._xBombSign = new PIXI.Sprite(FireInTheHole2.assetLoader.getTextures("xBomb_icon")[0]);
        this._xBombSign.anchor = new PIXI.Point(0.5, 1);
        this._xBombSign.position.set(11, 27);
        //this._multiplier.letterSpacing = -12;
        this.addChild(container, this._multiplier, this._xBombSign);
    }

    public checkServerData():void {
        if(this._multiplierValue != FireInTheHole2.model.gameData.multiplier) {
            debugger
        }
    }

    private rePosition(isNormal:boolean):void {
        if(NolimitApplication.isLandscape) {
            this.position.x = isNormal ? 797 : 777;
            this.position.y = isNormal ? 67 : 92;
        } else {
            this.position.x = isNormal ? 642 : 632;
            this.position.y = isNormal ? 10 : 11;
        }
    }

    public hide():void {
        this.visible = false;
    }

    public setMode(mode:string):void {
        const isNormal:boolean = mode[0] === "N";
        this._isNormal = isNormal;
        if(FireInTheHole2.model.freespinTriggeredThisSpin){
            this.update(0);
        }
        this.visible = true;
        this._xBombSign.visible = isNormal && this._multiplierValue < 2;
        this.update(this._multiplierValue);
        this.rePosition(isNormal);
    }

    public onResize():void {
        const isNormal:boolean = FireInTheHole2.model.isNormal;
        this.rePosition(isNormal);
    }

    get currentMultiplierValue():number {
        return this._multiplierValue;
    }
}